import { render, staticRenderFns } from "./VozIntroSection.vue?vue&type=template&id=622f01fa"
import script from "./VozIntroSection.vue?vue&type=script&lang=ts"
export * from "./VozIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./VozIntroSection.vue?vue&type=style&index=0&id=622f01fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports